import { Route, Routes } from 'react-router-dom';

import RouteWithTitle from '../../../../src/routes/RouteWithTitle';
import { PromptSettingPage } from '../promptSettings';
import CandidateSummary from '../promptSettings/CandidateSummary';
import PromptMainSetting from '../promptSettings/PromptMainSetting';

export const PromptSettingRoutes = () => (
  <Routes>
    <Route
      path="/*"
      element={
        <RouteWithTitle title="Prompt Setting - Wisestep">
          <PromptMainSetting />
        </RouteWithTitle>
      }
    />
  </Routes>
);
export const PromptSettingOptionsRoutes = () => (
  <Routes>
    <Route path="/" element={<PromptSettingPage />} />
    <Route path="/candidate-summary" element={<CandidateSummary />} />
  </Routes>
);
